import React, { Component } from "react";
import styled, { css } from "styled-components";
//import { observable } from "mobx";
import { observer } from "mobx-react";
import { graphql, compose } from "react-apollo";
import { store } from "./store";
import Avatar from "module-common/Avatar";
import IconRaw from "module-common/Icon";
import Header from "./header/HeaderWithStoreQuery";
import CampaignList from "./campaign/ListWithQuery";
import MemberList from './contact/MemberListWithQuery'
import TagList from './tags/ListWithQuery'

export default observer(
  class ModuleEmailCampaign extends Component {
    render() {      
      const selectedTab = store.selectedTab  
      return (
        <Wrapper>
          <Border width={"calc(50vh)"}>
            <WrapperBulkSms>
              <Header />
              {selectedTab == "campaign" && <CampaignList key="campaignList" />}
              {selectedTab == "audience" && <MemberList key="memberList" />}
              {selectedTab == "tags" && <TagList key="tagList" />}
            </WrapperBulkSms>
          </Border>
        </Wrapper>
      );
    }
  }
)

const Wrapper = styled.section`
  flex: 1;
  display: flex;
  flex-direction: row;
  box-shadow: none;
  background-color: #ebeef7;
  margin: -10px;
`;
const WrapperPost = styled.div`
  display: flex;
  flex: none;
  flex-direction: column;
  border-radius: 4px;
  border: 1px solid ${props => props.theme.panelBorder};
  margin: 5px 20px 10px;
`;
const WrapperBulkSms = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  border-right: 1px solid ${props => props.theme.panelBorder};
`;
const Border = styled.div`
  display: flex;
  flex: 1;
  border-radius: 4px;
  overflow: hidden;
  background-color: ${props => props.theme.panelBackground};
  box-shadow: ${props => props.theme.shadow};
  margin: 10px;
  flex-direction: column;
  ${props => props.width && css`width: ${props.width};`}
`;
const WrapperAccount = styled.div`
  display: flex;
  margin-left: 10px;
  overflow-x: scroll;
`;

const AccountWrapper = styled.div``;

const Account = styled.div`
  display: flex;
  min-width: 120px;
  min-height: 30px;
  border-radius: 4px;
  /* border: 1px solid ${props => props.theme.panelBorder};
  background-color: #ebeef7; */
  margin-bottom: 8px;
  margin-left: 10px;
  cursor: pointer;
  &:hover {
    border: 1px solid ${props => props.theme.blueButton};
  }
  ${props => {
    if (props.selectedChannelStyle) {
      return css`
        border: 1px solid ${props => props.theme.blueButton};
        background-color: #fff;
      `;
    } else {
      return css`
        border: 1px solid ${props => props.theme.panelBorder};
        background-color: #ebeef7;
      `;
    }
  }};
`;
const LeftColumn = styled.div`
  display: flex;
  flex: none;
  flex-direction: column;
  width: 30px;
  align-items: center;
  padding: 3px 20px 3px 20px;
`;
const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 10px 0 10px;
`;
const StyledAvatar = styled(Avatar)`
  width: 30px;
  height: 30px;
`;
const Username = styled.div`
  line-height: 1.2;
  margin-bottom: 10px;
  color: rgba(0, 0, 0, 0.65);
`;
const Title = styled.div`
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 20px;
  padding-left: 20px;
`;

const Bottom = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 50px;
  padding: 0 16px;
  align-items: space-between;
`;
const Signature = styled.span`
  font-size: 0.8rem;
  color: ${props => props.theme.uiText};
  margin-left: 4px;
  margin-top: 18px;
  margin-right: 20px;
`;
const Icon = styled(IconRaw)`
  margin-right: 10px;
`;
const SendButton = styled.button`
  display: flex;
  padding: 8px;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: none;
  border-radius: 20px;
  color: white;
  transition: 0.3s;
  cursor: pointer;
  font-size: 0.8rem;
  padding: 5px 15px;
  margin-left: 10px;
  background-color: ${props => props.theme.blueButton};
  &:focus {
    outline: none;
  }
  &:hover {
    opacity: 0.7;
  }
`;

const HiddenFileInput = styled.input.attrs({
  type: "file",
  accept: "image/*"
})`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
`;

const Wrap = styled.section`
  position: relative;
  display: inline-block;
`;
const Span = styled.span`
  color: #338dca;
`;
const TextArea = styled.section`
  padding-top: 30px;
`;
const LeftBottom = styled.div`
  display: flex;
  margin-left: auto;
`;
const RightBottom = styled.div`
  display: flex;
`;



// WEBPACK FOOTER //
// ./src/module-bulk-sms/ModuleBulkSmsWithQueryMutation.js